module.exports = __webpack_public_path__ + "static/media/Exams-bro.5d3ba523.png";